import { withTaskContext } from "@twilio/flex-ui";
import LeaveChatButton from "./LeaveChatButton";

export default withTaskContext(LeaveChatButton);
